// Finar İ8 — ay/yıl tarih girişi. `<input type="month">` desteklemeyen tarayıcılarda
// (masaüstü Firefox/Safari) düz metin kutusuna düşülür. Kopya TEK kaynak.
import { isMonthYearValue } from "@mahir/shared";

export const DATE_INPUT_COPY = {
  monthPlaceholder: "YYYY-AA",
  monthPattern: "\\d{4}-(0[1-9]|1[0-2])",
  monthInvalidHint: "Ay/yıl YYYY-AA biçiminde olmalı (ör. 2025-03)",
} as const;

/**
 * Metin kutusundaki ham girişin sunucuya gidecek karşılığı: boş → null (silme), tam ay/yıl →
 * değer, yarım/geçersiz → `undefined` (GÖNDERİLMEZ — her tuşta 422 üretmesin; yerelde kalır).
 */
export function monthYearToSend(raw: string): string | null | undefined {
  const v = raw.trim();
  if (v.length === 0) return null;
  return isMonthYearValue(v) ? v : undefined;
}

/** Tarayıcı `type="month"` destekliyor mu? (desteklemeyen tarayıcı tipi "text"e çevirir) */
export function supportsMonthInput(): boolean {
  if (typeof document === "undefined") return true;
  const el = document.createElement("input");
  el.setAttribute("type", "month");
  return el.type === "month";
}
